import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Card from '../../../components/Card';

Value.propTypes = {
  title: PropTypes.node.isRequired
};

export default function Value(props) {
  const { title } = props;

  return (
    <Card
      shadow={false}
      border={false}
      className={classNames(
        'p-6x cursor-pointerx hover:bg-cs-orange-50x',
        // 'border border-cs-gray-300 m-px',
        'flex flex-col sm:flex-row items-start sm:items-center gap-4'
      )}
    >
      <div className="flex flex-row items-start sm:items-center gap-4">
        {/*{props.icon && (*/}
        {/*  <props.icon className="w-7 h-7 text-cs-yellow-500"/>*/}
        {/*)}*/}
        {/*<div className="w-7 h-7 rounded-full flex justify-center text-sm text-white items-center bg-cs-orange-500 shadow-cs-flat">*/}
        {/*  <div>4</div>*/}
        {/*</div>*/}
        <div className="text-lg flex-1 text-cs-gray-700 font-semiboldx">
          {title}
        </div>
      </div>
    </Card>
  );
};
